import app from './app.js'

function initCanvasDraw() {

    let ifDraw,
        oCanvas,
        context

    let lineWidth = 3
    let prevX, prevY

    function canvasResize() {
        //没有他初始化好oCanvas宽高设置都有问题
        oCanvas.width = window.innerWidth
        oCanvas.height = window.innerHeight
    }

    this.init = function(canvas, component) {
        oCanvas = canvas
        context = oCanvas.getContext("2d")
        this.component = component
        canvasResize()
    }

    this.beginDraw = function(flag) {
        console.log(flag)
        //画点东西
        if (flag) { //打开画笔功能
            canvasResize()
            app.controls.enabled = false
            activate()
        } else {
            app.controls.enabled = true
            dispose()
        }
    }

    const touchStart = (ev)=> {
        ev.preventDefault()
        ev.stopPropagation()
        var touches = app.getOriginalEvent(ev).touches
        if (touches && touches.length === 1) {
            ev = touches[0]
        }
        app.controls.enabled = false
        ifDraw = true

        prevX = ev.clientX
        prevY = ev.clientY
    }

    const touchMove = (ev) => {
        ev.preventDefault()
        const touches = app.getOriginalEvent(ev).touches
        if (touches && touches.length === 1) {
            ev = touches[0]
        }
        if (!ifDraw) return
        context.globalCompositeOperation = "source-over"
        context.lineWidth = lineWidth

        context.beginPath()
        context.strokeStyle = this.component.state.colorItem
        context.moveTo(prevX, prevY)
        context.lineTo(ev.clientX, ev.clientY)
        context.stroke()
        prevX = ev.clientX
        prevY = ev.clientY
    }

    const touchEnd = (ev)=>{
        ev.preventDefault()
        ifDraw = false
    }

    function activate() {
        oCanvas.addEventListener('mousedown', touchStart, false)
        oCanvas.addEventListener('mousemove', touchMove, false)
        oCanvas.addEventListener('mouseup', touchEnd, false)
        oCanvas.addEventListener('mouseleave', touchEnd, false)

        oCanvas.addEventListener('touchstart', touchStart, false)
        oCanvas.addEventListener('touchmove', touchMove, false)
        oCanvas.addEventListener('touchend', touchEnd, false)
    }

    function dispose() {
        oCanvas.removeEventListener('mousedown', touchStart, false);
        oCanvas.removeEventListener('mousemove', touchMove, false);
        oCanvas.removeEventListener('mouseup', touchEnd, false);
        oCanvas.removeEventListener('mouseleave', touchEnd, false);

        oCanvas.removeEventListener('touchstart', touchStart, false)
        oCanvas.removeEventListener('touchmove', touchMove, false)
        oCanvas.removeEventListener('touchend', touchEnd, false)
    }

}

const CanvasDrawer = new initCanvasDraw()

export default CanvasDrawer




// WEBPACK FOOTER //
// ./src/pages/webgl/src/canvasDraw.js